import type { ColumnDef, PaginationState, SortingState, VisibilityState } from '@tanstack/react-table';
import type { GeoJsonProperties } from 'geojson';

export const columns: ColumnDef<GeoJsonProperties>[] = [
  {
    id: 'objectId',
    header: 'OBJECTID',
    accessorKey: 'OBJECTID',
  },
  {
    id: 'owner',
    header: 'Owner',
    accessorKey: 'owner',
  },
  {
    id: 'categoryRaw',
    header: 'Category Raw',
    accessorKey: 'category',
  },
  {
    id: 'source',
    header: 'Source',
    accessorKey: 'source',
  },
  {
    id: 'category',
    header: 'Category',
    accessorKey: 'categoryMapped',
  },
  {
    id: 'carrierName',
    header: 'Carrier Name',
    accessorKey: 'carrier_na',
  },
  {
    id: 'callSign',
    header: 'Call Sign',
    accessorKey: 'call_sign',
  },
  {
    id: 'height',
    header: 'Height',
    accessorKey: 'height',
  },
  {
    id: 'registration',
    header: 'Registration #',
    accessorKey: 'registrati',
  },
  {
    id: 'location',
    header: 'Location #',
    accessorKey: 'location_n',
  },
  {
    id: 'studyNumber',
    header: 'Study #',
    accessorKey: 'faa_study_',
  },
  {
    id: 'uniqueSystemId',
    header: 'Unique System ID',
    accessorKey: 'unique_sys',
  },
];

export const columnVisibility: VisibilityState = {
  objectId: false,
  categoryRaw: false,
};

export const pagination: PaginationState = {
  pageIndex: 0,
  pageSize: 100,
};

export const sorting: SortingState = [{ id: 'owner', desc: false }];
